package ai.wagemix.logic.share

import ai.wagemix.net.models.WMBadge
import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the share presenter (planning/analytics-plan.md §5, "Mix building").
 * The pay range itself is not sent, only whether one was given.
 */

/** [badgeTier] is the badge the range earns, or `null` without a range (or before the stats arrived). */
internal fun FSLog.sendWMMixShared(mixId: String, hasPayRange: Boolean, badgeTier: WMBadge?) {
    sendEventInclusive(severity = Severity.Info, eventName = "WMMixShared") {
        put("mix_id", mixId)
        put("has_pay_range", hasPayRange)
        badgeTier?.let { put("badge_tier", it.name) }
    }
}
